import IconWrapper from '@lmig/lmds-react-icons/dist/IconWrapper';
import React from 'react';
var IconEvoCheckmark = function IconEvoCheckmark(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", {
    className: "lmig-Icon lmig-Icon-Checkmark-Evo lm-Icon--color-blue",
    "aria-label": "Checkmark",
    width: "14",
    height: "10",
    viewBox: "0 0 14 10",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.51248 10C3.97797 10 3.45374 9.78836 3.04258 9.37566L0 6.24339L1.08957 5.12169L4.14244 8.26455C4.34802 8.47619 4.68722 8.47619 4.8928 8.26455L12.9104 0L14 1.12169L5.98238 9.37566C5.5815 9.78836 5.04699 10 4.51248 10Z",
    fill: "white"
  })));
};
export default IconEvoCheckmark;